import '../App.css';
import Product from './product';
import WatchProduct from './watchproduct';
import SHeader from './header';
import SFooter from './footer';
import {ProductList} from '../assets/productlist';
import { useSelector, useDispatch} from 'react-redux';
import {useNavigate} from "react-router-dom";
import { notification } from 'antd';
import {clearCart} from "../actions/actionCreators";

function Shop() {
    const navigate = useNavigate(); // <-- use hook in component
    const [api, contextHolder] = notification.useNotification();
    
    const dispatch = useDispatch();  
    const cartQty = useSelector((state) => state.cartQty);
    
    const checkout =()=>{
        if (cartQty === 0)
        {
            api.error({
                  message: `Cart Empty`,
                  description:`You have no item in your cart`,
                  placement: 'bottomLeft',
            });
        }
        else
        {
            navigate("/checkout");
        }
    };
   
    const removeAllItems =()=>{ 
        dispatch(clearCart());
        api.info({
              message: `Cart Empty`,
              description:`all items have been removed from cart`,
              placement: 'bottomLeft',
        });
    };
    
    return (
        <>        
        {contextHolder}
        <div className="container">
        <div className="oz-body-wrap">
            <SHeader/>
            <section>
                    <div className="row pt-50 justify-content-center">                
                            <h1 className="h1 text-black text-uppercase">SHOP</h1> 
                    </div>            
                    <div className="row pt-1 justify-content-center">      
                              <br/><span className="cart"> {cartQty} items in cart</span>
                    </div> 
            </section>
            <section className="banner-area relative pt-50">
                    <div className="row justify-content-around">   
                            <WatchProduct className="col-lg-12 col-sm-12" item={ProductList['watch']}/>
                    </div>
                    <div className="row justify-content-around">   
                            <Product className="col-lg-6 col-sm-12" item={ProductList['black-tshirt']}/>
                            <Product className="col-lg-6 col-sm-12" item={ProductList['white-tshirt']}/>
                    </div>
                    <div className="row justify-content-around"> 
                            <Product className="col-lg-6 col-sm-12" item={ProductList['black-hoodie']}/> 
                            <Product className="col-lg-6 col-sm-12" item={ProductList['white-hoodie']}/> 
                    </div>
            </section>
            <section>
                    <div className="row justify-content-center">   
                      <button className="primary-btn white-bg mr-1"><span className="mr-5" onClick={removeAllItems}>CLEAR CART</span><span className="lnr lnr-cross-circle"></span></button>
                      <button className="primary-btn white-bg  ml-1"><span className="mr-5" onClick={checkout}>CHECKOUT</span><span className="lnr lnr-arrow-right"></span></button>
                    </div>
            </section>
            <SFooter/>
        </div>
        </div>
        </>
    );
}

export default Shop;
